import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Link from 'next/link';
import style from './Navbar.module.scss';

const { logoAlt } = defineMessages({
  logoAlt: {
    id: 'web.nav.logo-alt',
    defaultMessage: 'TeslaEesti'
  }
});

export const GenericNavbarBrand: React.FC<{
  dark?: boolean;
}> = () => {
  const intl = useIntl();

  return (
    <Link className={`ml-auto ml-sm-auto mr-auto navbar-brand ${style.navbarBrand}`} href="/">
      {intl.formatMessage(logoAlt)}
    </Link>
  );
};
